const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "double bed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.05,37h42.39c6.51,0,11.8,5.29,11.8,11.8v5.17c0,1.67-1.36,3.03-3.03,3.03H7.28c-1.67,0-3.03-1.36-3.03-3.03v-5.17c0-6.51,5.29-11.8,11.8-11.8Z",
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25,39v-18.08c0-3.54,3.05-6.42,6.81-6.42h42.38c3.76,0,6.81,2.87,6.81,6.42v18.08",
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25,57h8v2.67c0,.46-.37.83-.83.83h-6.33c-.46,0-.83-.37-.83-.83v-2.67h0Z",
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.21,30h6.09c2.74,0,4.96,2.22,4.96,4.96v2.04h-16v-2.04c0-2.74,2.22-4.96,4.96-4.96Z",
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,30h6.09c2.74,0,4.96,2.22,4.96,4.96v2.04h-16v-2.04c0-2.74,2.22-4.96,4.96-4.96Z",
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.25,57h8v2.67c0,.46-.37.83-.83.83h-6.33c-.46,0-.83-.37-.83-.83v-2.67h0Z",
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.75,
    y1: 51,
    x2: 70.75,
    y2: 51,
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleBed);
export default __webpack_public_path__ + "static/media/double_bed.493da83678a57cc3bee45f11a832ec87.svg";
export { ForwardRef as ReactComponent };